import clsx from 'clsx';
import { NextPage } from 'next';
import generalConfig from '@/config/general';
import SEO from '@/components/head/Seo';
import Nav from '@/components/navigation/Public';
import Hero from '@/components/heros/Public';
import Directory, { DirectoryItem } from '@/components/lists/Directory';
import Footer from '@/components/legal/Footer';
import SignUpForm from '@/components/forms/Newsletter';
import layoutStyles from '@/components/Layout/styles.module.scss';
import weddingBudgetCalculator from '@/features/resources/WeddingBudgetCalculator/settings';
import TreadmillPaceCalculator from '@/features/resources/TreadmillPaceCalculator/settings';
import SwimPaceCalculator from '@/features/resources/SwimPaceCalculator/settings';
import RowingPaceCalculator from '@/features/resources/RowingPaceCalculator/settings';

// @ts-ignore
const Page: NextPage = () => {
  const heading = 'Calculators';
  const subHeading = `Explore immersive content made using ${generalConfig.productName}`;
  const pages = [
    weddingBudgetCalculator,
    TreadmillPaceCalculator,
    SwimPaceCalculator,
    RowingPaceCalculator,
  ];

  return (
    <>
      <SEO title={heading} description={subHeading} />
      <div role="main" className={clsx(layoutStyles.main, '-bgc-white')}>
        <Nav />
        <Hero heading={heading} subHeading={subHeading} />

        <Directory>
          {pages.map((page) => (
            <DirectoryItem
              key={page.slug}
              heading={page.heading || page.title || ''}
              description={page.description}
              timestamp={page.updatedAt}
              url={`/${page.slug}`}
              featuredImageUrl={page.images.resourceUrl}
              featuredImageAlt={page.images.resourceUrlAlt || ''}
            />
          ))}
        </Directory>

        <SignUpForm />
        <Footer />
      </div>
    </>
  );
};

export default Page;
